import React, { useState } from 'react';
import { useMutation, gql } from '@apollo/client';
import { Link } from 'react-router-dom';
import './Footer.css';

const SUBSCRIBE_TO_NEWSLETTER = gql`
  mutation subscribeEmailToNewsletter($email: String!) {
    subscribeEmailToNewsletter(email: $email) {
      status
    }
  }
`;

const Footer = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState(''); // 'success' or 'error'

  const [subscribeToNewsletter, { loading }] = useMutation(SUBSCRIBE_TO_NEWSLETTER);

  const handleSubscribe = async (e) => {
    e.preventDefault();

    if (!email) {
      setMessage('Please enter a valid email address');
      setMessageType('error');
      return;
    }

    try {
      const { data } = await subscribeToNewsletter({
        variables: { email }
      });

      if (data?.subscribeEmailToNewsletter?.status === 'SUBSCRIBED') {
        setMessage('Thank you for subscribing to our newsletter!');
        setMessageType('success');
        setEmail('');
      } else {
        setMessage('You are already subscribed to our newsletter.');
        setMessageType('success');
        setEmail('');
      }

      // Clear message after 5 seconds
      setTimeout(() => {
        setMessage('');
        setMessageType('');
      }, 5000);
    } catch (error) {
      console.error('Newsletter subscription error:', error);
      setMessage(error.message || 'Failed to subscribe. Please try again.');
      setMessageType('error');

      // Clear error message after 5 seconds
      setTimeout(() => {
        setMessage('');
        setMessageType('');
      }, 5000);
    }
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>About Us</h3>
          <ul>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>Information</h3>
          <ul>
            <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            <li><Link to="/terms-of-service">Terms of Service</Link></li>
            <li><Link to="/shipping-delivery">Shipping & Delivery</Link></li>
            <li><Link to="/returns-refunds">Returns & Refunds</Link></li>
          </ul>
        </div>

        <div className="footer-section newsletter">
          <h3>Newsletter</h3>
          <form className="newsletter-form" onSubmit={handleSubscribe}>
            <input
              type="email"
              placeholder="Enter your email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
            />
            <button type="submit" disabled={loading}>
              {loading ? 'Subscribing...' : 'Subscribe'}
            </button>
          </form>
          {message && (
            <div className={`newsletter-message ${messageType}`}>
              {message}
            </div>
          )}
        </div>
      </div>

      <div className="footer-bottom">
        <p>Copyright &copy; 2013-present Freento, Inc. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
